import { render, staticRenderFns } from "./langChanger.vue?vue&type=template&id=3c2f670b"
import script from "./langChanger.vue?vue&type=script&lang=js"
export * from "./langChanger.vue?vue&type=script&lang=js"
import style0 from "./langChanger.vue?vue&type=style&index=0&id=3c2f670b&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports